import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ItemStatusEnum } from '../../enum';
import { CoreStatus } from '../CoreStatus';

interface ItemStatusProps {
  value: ItemStatusEnum;
}

const ItemStatusColor = {
  [ItemStatusEnum.Ready]: '#D19500',
  [ItemStatusEnum.InProduction]: '#06B6D4',
  [ItemStatusEnum.Delivered]: '#22C55E',
  [ItemStatusEnum.OnHold]: '#A855F7',
  [ItemStatusEnum.Canceled]: '#737373',
};
export const ItemStatus: FC<ItemStatusProps> = ({ value }) => {
  const { t } = useTranslation('status', { keyPrefix: 'items' });

  return (
    <CoreStatus
      value={t(value, value)}
      backgroundColor={ItemStatusColor[value]}
    />
  );
};
